module.exports = __webpack_public_path__ + "static/media/9p.2d1e37cf.png";